import React, { useState, useEffect } from 'react';
import SessionTimeOutPopup from '../Components/SessionTimeOutPopup/timeOutPopup';
import { useIdleTimer } from 'react-idle-timer';
import UseAxios from '../Api/http/http';
import { expireToken } from '../Api/request/login';
import { SESSION_TIMEOUT_POP } from '../Constants/strings';
import Loader from '../Components/Loader';

const UserSession = (...props) => {
  const [showIdlePopUp, setShowIdlePopUp] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const updateLoginDetails = async (token) => {
    try {
      const response = await UseAxios(expireToken(token));
      console.log(response.data.message); // Token expired successfully
    } catch (error) {
      console.error(error.response?.data?.message || 'Error expiring token');
    }
  };

  const handleOnIdle = () => {
    const token = localStorage.getItem('authToken');
    setShowIdlePopUp(true);
    updateLoginDetails(token);
  };

  useIdleTimer({
    onIdle: handleOnIdle,
    debounce: 250,
    timeout: 1000 * 60 * 15, // 15 minutes timer set for idle screen
  });

  const handleLoginAction = () => {
    setIsLoading(true);
    setShowIdlePopUp(false);
    setTimeout(() => {
      window.location.href = '/'; // Redirect to the login page
    }, 1000);
  };

  const sessionTimeOut = 1000 * 60 * 15; // 15 minutes

  useEffect(() => {

    const handleBeforeUnload = () => {
      sessionStorage.setItem('isClosing', 'true');
      const token = localStorage.getItem('authToken');
      if (token) {
        localStorage.setItem('lastTabCloseTime', Date.now());
      }
      setTimeout(() => {
        sessionStorage.removeItem('isClosing');
      }, 1); // Slight delay to ensure the flag is cleared on refresh
    };

    const handleUnload = () => {
      const token = localStorage.getItem('authToken');
      if (sessionStorage.getItem('isClosing') === 'true') {
        if (token) {
          const lastTabCloseTime = localStorage.getItem('lastTabCloseTime');
          const currentTime = Date.now();

          // If the tab was closed more than sessionTimeOut milliseconds ago, logout the user
          if (lastTabCloseTime && currentTime - lastTabCloseTime > sessionTimeOut) {
            localStorage.removeItem('authToken');
            localStorage.removeItem('lastTabCloseTime');
            navigator.sendBeacon(updateLoginDetails(token), '');
          }
        }
      }
    };

    const checkSessionTimeout = () => {
      const token = localStorage.getItem('authToken');
      if (token) {
        const lastTabCloseTime = localStorage.getItem('lastTabCloseTime');
        const currentTime = Date.now();
        // If the tab was closed more than sessionTimeOut milliseconds ago, logout the user
        if (lastTabCloseTime && currentTime - lastTabCloseTime > sessionTimeOut) {
          window.location.href = '/'; // Redirect to the login page
          localStorage.removeItem('lastTabCloseTime');
          navigator.sendBeacon(updateLoginDetails(token), '');
        } else {
          localStorage.removeItem('lastTabCloseTime');
        }
      }
    };

    const handleStorageChange = (event) => {
      if (event.key === 'lastTabCloseTime') {
        checkSessionTimeout();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);
    window.addEventListener('storage', handleStorageChange);
    checkSessionTimeout();

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <>
      <SessionTimeOutPopup
        isModelOpen={showIdlePopUp}
        handleLoginAction={handleLoginAction}
        message={SESSION_TIMEOUT_POP.MESSAGE_TEXT}
      >
        {props}
      </SessionTimeOutPopup>
      {isLoading && (
        <Loader/>
      )}
    </>
  );
};

export default UserSession;
